import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "http://www.reeves.nl/upload/KQZ.gif",
        "alt": "Marine magnetic anomaly animation"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Time-calibration of ocean growth is most reliably achieved from the magnetic anomaly `}<strong parentName="p">{`stripes`}</strong>{` observed over oceans that are attributed to the unique pattern of
reversals in the geomagnetic field over geological time. Since there is little ocean still in existence worldwide older than about 200 Ma, it is only reversals in
the last 200 Myr that need concern us here. In this interval, the `}<strong parentName="p">{`Cretaceous quiet zone (KQZ)`}</strong>{` - resulting from the absence of geomagnetic reversals in the 38 Myr interval from about 121 to about 84 Ma - takes up an important part of the process of Gondwana dispersal off southern Africa and around the Bouvet triple junction. Our dispersal model may then be considered in three parts as far as the control provided by ocean-floor magnetic stripes is concerned:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`From the present day back to Cenozoic anomaly C34 (83.64 Ma) magnetic anomaly stripes are mostly well-determined by observations. Ocean growth was rather
regular and the large areas of ocean created are covered by large numbers of tracklines followed by marine research vessels towing magnetometers. The outlines of the continental plates are mostly well-established, so there is little ambiguity in their paleo-positions.  We have therefore paid relatively little attention to revising published Euler rotation parameters for the main Gondwana fragments in this interval.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`From C34 (83.64 Ma) to M0 (121.4 Ma) there are no magnetic anomalies so we have to rely on other methods to constrain the paleo-positions of the Gondwana
fragments. This is an important interval since, at its start, the spreading of the Gondwana fragments is still in its early stages while, at its end, the future pattern of dispersal is in large part well-established.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Before M0 (121.4 Ma) we have to rely on a rather limited set of magnetic anomaly observations to constrain the early movements of the fragments. The problem is
complicated by the difficulty of recording anomalies reliably close to continental margins and the complications introduced when fragments are at close separations
by early ridge-jumps as smaller fragments show uncertain allegiance to one or other of their parent fragments in the early stages of dispersal. Around the Bouvet
triple junction the picture is further complicated by jumps in the location of the triple junction itself and the multiplicity of small fragments that this creates.`}</p>
      </li>
    </ol>
    <h2>{`A lot happened while there were no geomagnetic reversals`}</h2>
    <p>{`The animation attempts to illustrate these points and the solution our model offers. The movements of the main fragments are as smooth as possible through the KQZ and,
once the M-series anomalies punctuate the oldest pieces of ocean, they are used to constrain the earliest phases of continental dispersal.  The anomalies in the
Africa-Antarctica corridor are most important but even these become uncertain about 25 Myr after initial disruption started (i.e. before about 160 Ma).  The presence of sub-fragments in South
America (and possibly in Africa too) lends uncertainty to the interpretation of the anomalies in the southernmost South Atlantic. Anomalies in the Weddell Sea are
clear, particularly in the interval 142.3 to 121.4 Ma, but the conjugate ocean off South America has been lost to subduction. A parallel problem exists off Australia-
Antarctica where the conjugate margin (Greater India?) now lies within the Himalayas.  Between Madagascar and Africa, observations of magnetic anomalies are limited
and perhaps corrupted by subsequent volcanic activity on the ocean floor.  Our model offers a solution that maximises smooth movements and minimises the invention of
jumps or speed variations that are not supported by observation.`}</p>
    <p>{` `}<em parentName="p">{`Latest update: 2024 February 10`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      